import styles from "./LogoutPopup.module.css";

export default function LogoutPopup({ onConfirm, onCancel }) {
  return (
    <div className={styles.popupOverlay}>
      <div className={styles.popupCard}>
        <div className={styles.popupIcon}>👋</div>
        <div className={styles.popupTitle}>Do you want to logout?</div>
        <div className={styles.popupBtns}>
          <button className={styles.popupCancel} onClick={onCancel}>
            Cancel
          </button>
          <button className={styles.popupConfirm} onClick={onConfirm}>
            Logout
          </button>
        </div>
      </div>
    </div>
  );
}
